import React, { useState, useEffect, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import LanguageSelector from '../components/LanguageSelector';
import { WorkCard, WorkModal } from '../components/ShowcaseCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrabajosPage() {
  const { t } = useTranslation();
  const [works, setWorks] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const wid = searchParams.get('work');
    if (wid && works.length > 0) {
      const w = works.find(x => x.id === wid);
      if (w) setSelected(w);
    }
  }, [works, searchParams]);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/showcase`);
      setWorks(res.data.works || []);
    } catch { /* ignore */ }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-screen bg-background">
      <nav className="relative z-50 glass border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-zinc-400 hover:text-white text-sm">
            <ArrowLeft className="w-4 h-4" /> AR Performance
          </Link>
          <LanguageSelector />
        </div>
      </nav>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white mb-2">{t('TRABAJOS REALIZADOS')}</h1>
        <p className="text-zinc-400 mb-10">{t('Vehículos reprogramados por nuestro equipo: fotos, gráficas de potencia y software realizado')}</p>
        {loading ? (
          <p className="text-zinc-500">...</p>
        ) : works.length === 0 ? (
          <p className="text-zinc-500" data-testid="no-works">{t('Próximamente publicaremos nuestros trabajos')}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="works-grid">
            {works.map(w => <WorkCard key={w.id} work={w} onClick={() => setSelected(w)} />)}
          </div>
        )}
      </div>
      <WorkModal work={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
